import BugCatch, { EventPayload } from 'bugcatch-sdk';

const dsn = String(process.env.VITE_BUGCATCH_DSN);

const isBugCatchEnabled = Boolean(dsn);

if (isBugCatchEnabled) {
    BugCatch.init({
        dsn,
        release: process.env.VITE_APP_VERSION,
        environment: process.env.NODE_ENV,
        ignoreErrors: [/ResizeObserver loop limit exceeded/, /Network Error/],
        beforeSend(event: EventPayload) {
            event.platform = 'web';
            return event;
        },
    });
}

export const bugCatchEnabled = isBugCatchEnabled;

export default BugCatch;
